
import axios from 'axios'
import { useEffect } from 'react'

//synchronous action creator


const fetchMoviesData= (movies) => ({


    type: 'FETCH_MOVIES',
    payload: {movies}
})


const updateMoviesData = (movies) => ({

    type: 'UPDATE_MOVIES',
    payload: {movies}
})

export const editPost = (movies) => (dispatch) => {
    dispatch(updateMoviesData(movies));
  };

export const fetchMovies =  () => {
    return async dispatch => {
        try {
            //let posts = await axios.get('https://mychannel7tv.co.uk/wp-json/wp/v2/show')
            let posts  = await axios.get('https://nastaanaisie.pythonanywhere.com/api/movies/')
            dispatch(fetchMoviesData(posts.data)) //store first five posts
           // dispatch(loading(true))

          
        }
        catch(e){
            console.log(e)
        }
    }
}

